module.exports = __webpack_public_path__ + "img/108.2f54cb10.webp";